export interface BondPriceObject {
  bond: string;
  created_at: string;
  currency: 'USD' | 'AUD';
  price: string;
  price_date: string;
  price_id: string;
  price_source: string;
  resource_uri: string;
}

export interface BondPriceResponse {
  meta: {
    limit: number;
    next: string | null;
    offset: number;
    previous: string | null;
    total_count: number;
  };
  objects: BondPriceObject[];
}

export type Currency = 'USD' | 'AUD';

export enum BondPriceQueryKeys {
  BondPrice = 'bond_price',
}
